import { createPortal } from "react-dom";
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";

interface ConfirmModalProps {
  show: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  color?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Small confirmation dialog. It is rendered at the end of the page so it can
 * open on top of another modal, and it dims that modal with its own
 * background because CoreUI's backdrop would sit underneath it.
 */
const ConfirmModal = ({
  show,
  title,
  message,
  confirmLabel,
  color = "primary",
  onConfirm,
  onCancel,
}: ConfirmModalProps) =>
  createPortal(
    <CModal
      show={show}
      size="sm"
      centered
      backdrop={false}
      onClose={onCancel}
      style={{ zIndex: 1070, backgroundColor: "rgba(0, 0, 21, 0.5)" }}
    >
      <CModalHeader closeButton>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody>{message}</CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Cancelar
        </CButton>
        <CButton color={color} onClick={onConfirm}>
          {confirmLabel}
        </CButton>
      </CModalFooter>
    </CModal>,
    document.body,
  );

export default ConfirmModal;
